import React, {useContext, useState} from "react";
import LoaderCircle from "../../../loader/LoaderCircle";
import "../../../../css/page/content/catalog/OtamiSynchronized.css";
import ProductController from "../../../../stories/_catalog/Products/ProductController";
import StoreSettingController from "../../../../stories/_setting/StoreSettings/StoreSettingController";
import BackofficeContext from "../../../../context/BackofficeContext";

const OtamiSynchronized = () => {
    const [ loading, setLoading ] = useState(false);
    const { setEvent } = useContext(BackofficeContext);

    const sync = () => {
        if (loading)
            return;

        setLoading(true);

        const controller = new ProductController();
        controller._callback = returnSync;
        controller.externalSynchronize("otami");
    }
    const returnSync = (response, error, status) => {
        switch (status) {
            case 201:
                getStoreSettings();
                break;
            default:
                setLoading(false);

                setEvent({
                    type: "error",
                    text: "Une erreur s'est produite lors de la synchronisation avec OTAMI"
                });

                break;
        }
    }
    const getStoreSettings = () => {
        let controller = new StoreSettingController();
        controller._callback = handleGetStoreSettings;
        controller.show(JSON.parse(localStorage.getItem("store")).id);
    }
    const handleGetStoreSettings = (object, error, status) => {
        switch (status) {
            case 200:
                localStorage.setItem("storeSettings", JSON.stringify(object));
                break
            default: break;
        }

        setLoading(false);
    }

    return(
        <button className={"button blue " + (loading ? " loading" : " otami")} onClick={sync}>
            {
                loading
                    ? <div className={"loadingContent"}><LoaderCircle display={"loadingOtami"} stroke={"#00406F"} strokeWidth="12" /><span>Envoi en cours ...</span></div>
                    : <span>Synchroniser avec OTAMI</span>
            }
        </button>
    )
}

export default OtamiSynchronized;